import { emptyApi as api } from './empty-api'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createApiKey: build.mutation<CreateApiKeyApiResponse, CreateApiKeyApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/api-keys`,
        method: 'POST',
        body: queryArg
      })
    }),
    listDevicePairings: build.query<ListDevicePairingsApiResponse, ListDevicePairingsApiArg>({
      query: () => ({ url: `/api/v2/device-pairings` })
    }),
    createDevicePairing: build.mutation<CreateDevicePairingApiResponse, CreateDevicePairingApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/device-pairings`,
        method: 'POST',
        body: queryArg
      })
    }),
    getDevicePairing: build.query<GetDevicePairingApiResponse, GetDevicePairingApiArg>({
      query: (queryArg) => ({ url: `/api/v2/device-pairings/${queryArg}` })
    }),
    revokeDevicePairing: build.mutation<RevokeDevicePairingApiResponse, RevokeDevicePairingApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/device-pairings/${queryArg}`,
        method: 'DELETE'
      })
    }),
    claimDevicePairing: build.mutation<ClaimDevicePairingApiResponse, ClaimDevicePairingApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/device-pairings/${queryArg.id}/claim`,
        method: 'POST',
        body: queryArg.body
      })
    }),
    confirmDevicePairing: build.mutation<
      ConfirmDevicePairingApiResponse,
      ConfirmDevicePairingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/device-pairings/${queryArg.id}/confirm`,
        method: 'POST',
        body: queryArg.body
      })
    }),
    rejectDevicePairing: build.mutation<RejectDevicePairingApiResponse, RejectDevicePairingApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/device-pairings/${queryArg.id}/reject`,
        method: 'POST',
        body: queryArg.body
      })
    }),
    getGroups: build.query<GetGroupsApiResponse, GetGroupsApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/groups`,
        params: {
          userId: queryArg.userId,
          page: queryArg.page,
          perPage: queryArg.perPage
        }
      })
    }),
    createGroup: build.mutation<CreateGroupApiResponse, CreateGroupApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/groups`,
        method: 'POST',
        body: queryArg
      })
    }),
    getGroup: build.query<GetGroupApiResponse, GetGroupApiArg>({
      query: (queryArg) => ({ url: `/api/v2/groups/${queryArg}` })
    }),
    deleteGroup: build.mutation<DeleteGroupApiResponse, DeleteGroupApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/groups/${queryArg}`,
        method: 'DELETE'
      })
    }),
    updateGroup: build.mutation<UpdateGroupApiResponse, UpdateGroupApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/groups/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.entitiesUpdateGroupRequest
      })
    }),
    getGroupMembers: build.query<GetGroupMembersApiResponse, GetGroupMembersApiArg>({
      query: (queryArg) => ({ url: `/api/v2/groups/${queryArg}/members` })
    }),
    addGroupMembers: build.mutation<AddGroupMembersApiResponse, AddGroupMembersApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/groups/${queryArg.id}/members`,
        method: 'POST',
        body: queryArg.entitiesAddGroupMembersRequest
      })
    }),
    removeGroupMember: build.mutation<RemoveGroupMemberApiResponse, RemoveGroupMemberApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/groups/${queryArg.id}/members/${queryArg.userId}`,
        method: 'DELETE'
      })
    }),
    getRoles: build.query<GetRolesApiResponse, GetRolesApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/roles`,
        params: {
          product: queryArg.product,
          page: queryArg.page,
          perPage: queryArg.perPage
        }
      })
    }),
    getRoleAssignments: build.query<GetRoleAssignmentsApiResponse, GetRoleAssignmentsApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/roles/assignments`,
        params: {
          product: queryArg.product,
          userId: queryArg.userId,
          roleId: queryArg.roleId,
          roleName: queryArg.roleName,
          machineId: queryArg.machineId,
          enabled: queryArg.enabled,
          page: queryArg.page,
          perPage: queryArg.perPage
        }
      })
    }),
    createRoleAssignment: build.mutation<
      CreateRoleAssignmentApiResponse,
      CreateRoleAssignmentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/roles/assignments`,
        method: 'POST',
        body: queryArg
      })
    }),
    getGroupedRoleAssignments: build.query<
      GetGroupedRoleAssignmentsApiResponse,
      GetGroupedRoleAssignmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/roles/assignments/grouped`,
        params: {
          product: queryArg.product,
          page: queryArg.page,
          perPage: queryArg.perPage
        }
      })
    }),
    updateRoleAssignment: build.mutation<
      UpdateRoleAssignmentApiResponse,
      UpdateRoleAssignmentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/roles/assignments/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.body
      })
    }),
    deleteRoleAssignment: build.mutation<
      DeleteRoleAssignmentApiResponse,
      DeleteRoleAssignmentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/roles/assignments/${queryArg}`,
        method: 'DELETE'
      })
    }),
    getRoleAssignmentsForRole: build.query<
      GetRoleAssignmentsForRoleApiResponse,
      GetRoleAssignmentsForRoleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/roles/${queryArg.roleId}/assignments`,
        params: {
          product: queryArg.product,
          userId: queryArg.userId,
          enabled: queryArg.enabled,
          page: queryArg.page,
          perPage: queryArg.perPage
        }
      })
    }),
    login: build.mutation<LoginApiResponse, LoginApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/sessions`,
        method: 'POST',
        body: queryArg
      })
    }),
    getAuthenticationConfig: build.query<
      GetAuthenticationConfigApiResponse,
      GetAuthenticationConfigApiArg
    >({
      query: () => ({ url: `/api/v2/sessions/authentication-config` })
    }),
    sessionOidcAuthentication: build.mutation<
      SessionOidcAuthenticationApiResponse,
      SessionOidcAuthenticationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/sessions/oidc`,
        method: 'POST',
        body: queryArg
      })
    }),
    accountRecovery: build.mutation<AccountRecoveryApiResponse, AccountRecoveryApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/sessions/recovery`,
        method: 'PUT',
        body: queryArg
      })
    }),
    refreshSession: build.mutation<RefreshSessionApiResponse, RefreshSessionApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/sessions/refresh`,
        method: 'POST',
        body: queryArg
      })
    }),
    logout: build.mutation<LogoutApiResponse, LogoutApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/sessions/${queryArg}`,
        method: 'DELETE'
      })
    }),
    getUsers: build.query<GetUsersApiResponse, GetUsersApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/users`,
        params: {
          page: queryArg.page,
          perPage: queryArg.perPage,
          enabled: queryArg.enabled,
          search: queryArg.search,
          serviceAccounts: queryArg.serviceAccounts
        }
      })
    }),
    createUser: build.mutation<CreateUserApiResponse, CreateUserApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/users`,
        method: 'POST',
        body: queryArg
      })
    }),
    checkMfa: build.mutation<CheckMfaApiResponse, CheckMfaApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/users/check-mfa`,
        method: 'POST',
        body: queryArg
      })
    }),
    getCurrentUser: build.query<GetCurrentUserApiResponse, GetCurrentUserApiArg>({
      query: () => ({ url: `/api/v2/users/current` })
    }),
    updateAccountInfo: build.mutation<UpdateAccountInfoApiResponse, UpdateAccountInfoApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/users/current`,
        method: 'PUT',
        body: queryArg
      })
    }),
    deleteCurrentUserMfa: build.mutation<
      DeleteCurrentUserMfaApiResponse,
      DeleteCurrentUserMfaApiArg
    >({
      query: () => ({ url: `/api/v2/users/current/mfa`, method: 'DELETE' })
    }),
    updateCurrentUserPassword: build.mutation<
      UpdateCurrentUserPasswordApiResponse,
      UpdateCurrentUserPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/users/current/password`,
        method: 'PUT',
        body: queryArg
      })
    }),
    enableMfa: build.mutation<EnableMfaApiResponse, EnableMfaApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/users/mfa`,
        method: 'POST',
        body: queryArg
      })
    }),
    currentUserGenerateMfaSecret: build.mutation<
      CurrentUserGenerateMfaSecretApiResponse,
      CurrentUserGenerateMfaSecretApiArg
    >({
      query: () => ({ url: `/api/v2/users/mfa-secret`, method: 'POST' })
    }),
    changeInitialPassword: build.mutation<
      ChangeInitialPasswordApiResponse,
      ChangeInitialPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/users/onboarding/change-initial-password`,
        method: 'POST',
        body: queryArg
      })
    }),
    updateUser: build.mutation<UpdateUserApiResponse, UpdateUserApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/users/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.entitiesUpdateCurrentUserRequest
      })
    }),
    disableUser: build.mutation<DisableUserApiResponse, DisableUserApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/users/${queryArg}/disable`,
        method: 'POST'
      })
    }),
    enableUser: build.mutation<EnableUserApiResponse, EnableUserApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/users/${queryArg}/enable`,
        method: 'POST'
      })
    }),
    updateUserPassword: build.mutation<UpdateUserPasswordApiResponse, UpdateUserPasswordApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/users/${queryArg}/password`,
        method: 'PUT'
      })
    }),
    listUserSessions: build.query<ListUserSessionsApiResponse, ListUserSessionsApiArg>({
      query: (queryArg) => ({ url: `/api/v2/users/${queryArg}/sessions` })
    }),
    createUserSession: build.mutation<CreateUserSessionApiResponse, CreateUserSessionApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/users/${queryArg.id}/sessions`,
        method: 'POST',
        body: queryArg.body
      })
    }),
    deleteUserSession: build.mutation<DeleteUserSessionApiResponse, DeleteUserSessionApiArg>({
      query: (queryArg) => ({
        url: `/api/v2/users/${queryArg.id}/sessions/${queryArg.sessionId}`,
        method: 'DELETE'
      })
    })
  }),
  overrideExisting: false
})
export { injectedRtkApi as generatedApi }
export type CreateApiKeyApiResponse = /** status 201 Created */ EntitiesCreateApiKeyResponse
export type CreateApiKeyApiArg = /** API key */ EntitiesCreateApiKeyBody
export type ListDevicePairingsApiResponse = /** status 200 OK */ EntitiesListDevicePairingsResponse
export type ListDevicePairingsApiArg = void
export type CreateDevicePairingApiResponse =
  /** status 201 Created */ EntitiesCreateDevicePairingResponse
export type CreateDevicePairingApiArg = /** Issuer details */ EntitiesCreateDevicePairingRequest
export type GetDevicePairingApiResponse = /** status 200 OK */ EntitiesDevicePairingResponse
export type GetDevicePairingApiArg = /** Device pairing ID */ string
export type RevokeDevicePairingApiResponse = unknown
export type RevokeDevicePairingApiArg = /** Device pairing ID */ string
export type ClaimDevicePairingApiResponse = /** status 200 OK */ EntitiesClaimDevicePairingResponse
export type ClaimDevicePairingApiArg = {
  /** Device pairing ID */
  id: string
  /** Secret and device name */
  body: EntitiesClaimDevicePairingRequestBody
}
export type ConfirmDevicePairingApiResponse = /** status 200 OK */ EntitiesCreateSessionResponse
export type ConfirmDevicePairingApiArg = {
  /** Device pairing ID */
  id: string
  /** Pairing secret */
  body: EntitiesDevicePairingSecretRequestBody
}
export type RejectDevicePairingApiResponse = unknown
export type RejectDevicePairingApiArg = {
  /** Device pairing ID */
  id: string
  /** Pairing secret */
  body: EntitiesDevicePairingSecretRequestBody
}
export type GetGroupsApiResponse = /** status 200 OK */ EntitiesListGroupsResponse
export type GetGroupsApiArg = {
  /** Filter by member user ID */
  userId?: string
  /** Page number (default 1) */
  page?: number
  /** Items per page (default 10, max 100) */
  perPage?: number
}
export type CreateGroupApiResponse = /** status 201 Created */ EntitiesGroupResponse
export type CreateGroupApiArg = /** Group payload */ EntitiesCreateGroupRequest
export type GetGroupApiResponse = /** status 200 OK */ EntitiesGroupResponse
export type GetGroupApiArg = /** Group ID */ string
export type DeleteGroupApiResponse = unknown
export type DeleteGroupApiArg = /** Group ID */ string
export type UpdateGroupApiResponse = /** status 200 OK */ EntitiesGroupResponse
export type UpdateGroupApiArg = {
  /** Group ID */
  id: string
  /** Group update payload */
  entitiesUpdateGroupRequest: EntitiesUpdateGroupRequest
}
export type GetGroupMembersApiResponse = /** status 200 OK */ EntitiesGroupMemberResponse[]
export type GetGroupMembersApiArg = /** Group ID */ string
export type AddGroupMembersApiResponse = unknown
export type AddGroupMembersApiArg = {
  /** Group ID */
  id: string
  /** Group members payload */
  entitiesAddGroupMembersRequest: EntitiesAddGroupMembersRequest
}
export type RemoveGroupMemberApiResponse = unknown
export type RemoveGroupMemberApiArg = {
  /** Group ID */
  id: string
  /** User ID */
  userId: string
}
export type GetRolesApiResponse = /** status 200 OK */ EntitiesListRolesResponse
export type GetRolesApiArg = {
  /** Filter by product (repeatable); roles matching any given product are returned */
  product: ('devops' | 'ontology')[]
  /** Page number (default 1) */
  page?: number
  /** Items per page (default 10, max 100) */
  perPage?: number
}
export type GetRoleAssignmentsApiResponse = /** status 200 OK */ EntitiesListRoleAssignmentsResponse
export type GetRoleAssignmentsApiArg = {
  /** Filter by product (repeatable); assignments whose role matches any given product are returned */
  product: ('devops' | 'ontology')[]
  /** Filter by user ID */
  userId?: string
  /** Filter by role ID */
  roleId?: string
  /** Filter by role name */
  roleName?:
    | 'developer'
    | 'machine_admin'
    | 'global_admin'
    | 'operator'
    | 'viewer'
    | 'engineer'
    | 'admin'
    | 'service_account'
    | 'maintenance'
    | 'ingest_uploader'
    | 'devops_sync'
  /** Filter by machine ID inside scope */
  machineId?: string
  /** Filter by users.enabled on the assignee. Omit to return all assignments; pass true/false to narrow. */
  enabled?: boolean
  /** Page number (default 1) */
  page?: number
  /** Items per page (default 10, max 100) */
  perPage?: number
}
export type CreateRoleAssignmentApiResponse =
  /** status 201 Created */ EntitiesCreateRoleAssignmentResponse
export type CreateRoleAssignmentApiArg =
  /** Assignment payload */ EntitiesCreateRoleAssignmentRequestBody
export type GetGroupedRoleAssignmentsApiResponse =
  /** status 200 OK */ EntitiesListGroupedRoleAssignmentsResponse
export type GetGroupedRoleAssignmentsApiArg = {
  /** Filter by product (repeatable) */
  product: ('devops' | 'ontology')[]
  /** Page number (default 1) */
  page?: number
  /** Roles per page (default 20, max 100) */
  perPage?: number
}
export type UpdateRoleAssignmentApiResponse =
  /** status 200 OK */ EntitiesUpdateRoleAssignmentResponse
export type UpdateRoleAssignmentApiArg = {
  /** Role assignment ID */
  id: string
  /** Scope update payload */
  body: EntitiesUpdateRoleAssignmentRequestBody
}
export type DeleteRoleAssignmentApiResponse =
  /** status 200 OK */ EntitiesDeleteRoleAssignmentResponse
export type DeleteRoleAssignmentApiArg = /** Role assignment ID */ string
export type GetRoleAssignmentsForRoleApiResponse =
  /** status 200 OK */ EntitiesListRoleAssignmentsResponse
export type GetRoleAssignmentsForRoleApiArg = {
  /** Role ID */
  roleId: string
  /** Filter by product (repeatable) */
  product: ('devops' | 'ontology')[]
  /** Filter by assignee user ID */
  userId?: string
  /** Filter by whether the assignee is enabled */
  enabled?: boolean
  /** Page number (default 1) */
  page?: number
  /** Assignments per page (default 100, max 100) */
  perPage?: number
}
export type LoginApiResponse = /** status 200 OK */ EntitiesCreateSessionResponse
export type LoginApiArg = /** Credentials */ EntitiesCreateSessionRequest
export type GetAuthenticationConfigApiResponse =
  /** status 200 OK */ EntitiesAuthenticationConfigResponse
export type GetAuthenticationConfigApiArg = void
export type SessionOidcAuthenticationApiResponse =
  /** status 200 OK */ EntitiesCreateSessionResponse
export type SessionOidcAuthenticationApiArg =
  /** OIDC tokens + client */ EntitiesCreateOidcSessionRequest
export type AccountRecoveryApiResponse = unknown
export type AccountRecoveryApiArg = /** Recovery payload */ EntitiesRecoverPasswordRequest
export type RefreshSessionApiResponse = /** status 200 OK */ EntitiesCreateSessionResponse
export type RefreshSessionApiArg = /** Refresh payload */ EntitiesRefreshSessionRequest
export type LogoutApiResponse = unknown
export type LogoutApiArg = /** Session ID */ string
export type GetUsersApiResponse = /** status 200 OK */ EntitiesListUsersResponse
export type GetUsersApiArg = {
  /** Page number (default 1) */
  page?: number
  /** Items per page (default 10, max 100) */
  perPage?: number
  /** Filter by users.enabled. Omit to return all users; pass true/false to narrow. */
  enabled?: boolean
  /** Case-insensitive substring match on username, name, or email. Omit or blank to return all users that pass the enabled filter. */
  search?: string
  /** How users assigned the service_account role appear. Defaults to include. `only` also embeds each account's sessions. */
  serviceAccounts?: 'include' | 'exclude' | 'only'
}
export type CreateUserApiResponse = /** status 200 OK */ EntitiesCreateUserResponse
export type CreateUserApiArg = /** Username, name, and optional email */ EntitiesCreateUserRequest
export type CheckMfaApiResponse = /** status 200 OK */ EntitiesCheckMfaResponse
export type CheckMfaApiArg = /** Username and password */ EntitiesCheckMfaRequest
export type GetCurrentUserApiResponse = /** status 200 OK */ EntitiesUserResponse
export type GetCurrentUserApiArg = void
export type UpdateAccountInfoApiResponse = /** status 200 OK */ EntitiesUserResponse
export type UpdateAccountInfoApiArg =
  /** Identity fields to update */ EntitiesUpdateCurrentUserRequest
export type DeleteCurrentUserMfaApiResponse = unknown
export type DeleteCurrentUserMfaApiArg = void
export type UpdateCurrentUserPasswordApiResponse = unknown
export type UpdateCurrentUserPasswordApiArg =
  /** Password change payload */ EntitiesUpdateCurrentPasswordRequest
export type EnableMfaApiResponse = unknown
export type EnableMfaApiArg = /** TOTP verification payload */ EntitiesEnableMfaRequest
export type CurrentUserGenerateMfaSecretApiResponse =
  /** status 200 OK */ EntitiesGenerateMfaSecretResponse
export type CurrentUserGenerateMfaSecretApiArg = void
export type ChangeInitialPasswordApiResponse =
  /** status 200 OK */ EntitiesChangeInitialPasswordResponse
export type ChangeInitialPasswordApiArg =
  /** Initial password change payload */ EntitiesChangeInitialPasswordRequest
export type UpdateUserApiResponse = /** status 200 OK */ EntitiesUserResponse
export type UpdateUserApiArg = {
  /** User ID */
  id: string
  /** Identity fields to update */
  entitiesUpdateCurrentUserRequest: EntitiesUpdateCurrentUserRequest
}
export type DisableUserApiResponse = unknown
export type DisableUserApiArg = /** User ID */ string
export type EnableUserApiResponse = unknown
export type EnableUserApiArg = /** User ID */ string
export type UpdateUserPasswordApiResponse = /** status 200 OK */ EntitiesResetUserPasswordResponse
export type UpdateUserPasswordApiArg = /** User ID */ string
export type ListUserSessionsApiResponse = /** status 200 OK */ EntitiesListUserSessionsResponse
export type ListUserSessionsApiArg = /** User ID */ string
export type CreateUserSessionApiResponse = /** status 200 OK */ EntitiesCreateUserSessionResponse
export type CreateUserSessionApiArg = {
  /** User ID */
  id: string
  /** Token lifetime */
  body: EntitiesCreateUserSessionBody
}
export type DeleteUserSessionApiResponse = unknown
export type DeleteUserSessionApiArg = {
  /** User ID */
  id: string
  /** Session ID */
  sessionId: string
}
export type EntitiesCreateUserSessionResponse = {
  accessToken: string
  expiresAt: string
  id: string
  userId: string
}
export type EntitiesUserLdap = {
  dn?: string
  enabled: boolean
}
export type EntitiesUserMfa = {
  enabled: boolean
  required: boolean
}
export type EntitiesUserOidc = {
  enabled: boolean
  id?: string
}
export type UserOnboardingStatus = 'pending' | 'completed'
export type IdentityApiEntitiesUserOnboardingSteps = {
  initialPasswordChanged: boolean
  mfaEnabled: boolean
}
export type IdentityApiEntitiesUserOnboarding = {
  status: UserOnboardingStatus
  steps: IdentityApiEntitiesUserOnboardingSteps
}
export type RbacRole =
  | 'developer'
  | 'machine_admin'
  | 'global_admin'
  | 'operator'
  | 'viewer'
  | 'engineer'
  | 'admin'
  | 'service_account'
  | 'maintenance'
  | 'ingest_uploader'
  | 'devops_sync'
export type EntitiesUserRoleRef = {
  id: string
  name: RbacRole
}
export type EntitiesUserRoleAssignmentResponse = {
  id: string
  role: EntitiesUserRoleRef
  scope: string[]
}
export type EntitiesSessionResponse = {
  createdAt: string
  createdBy?: string | null
  expiresAt?: string | null
  id: string
  lastUsedAt?: string | null
  userId: string
}
export type EntitiesUserResponse = {
  changedInitialPassword: boolean
  createdAt: string
  email?: string
  enabled: boolean
  id: string
  ldap: EntitiesUserLdap
  mfa: EntitiesUserMfa
  name: string
  oidc: EntitiesUserOidc
  onboarding: IdentityApiEntitiesUserOnboarding
  roleAssignments: EntitiesUserRoleAssignmentResponse[]
  /** Sessions is present only when listing service accounts
    (serviceAccounts=only) and on API-key creation: every session of the
    account, newest first. Access tokens are never included. */
  sessions?: EntitiesSessionResponse[]
  updatedAt: string
  username: string
}
export type EntitiesCreateApiKeyResponse = {
  token: EntitiesCreateUserSessionResponse
  user: EntitiesUserResponse
}
export type WebErrorResponse = {
  code: number
  errors: {
    [key: string]: string[]
  }
  messages: string[]
}
export type EntitiesCreateApiKeyBody = {
  expiresInSeconds: number
  name: string
  permissions: ('ingest/push' | 'devops-sync/read')[]
}
export type EntitiesPairedDeviceResponse = {
  confirmedAt: string
  deviceName: string
  id: string
  lastUsedAt?: string | null
  sessionId: string
}
export type EntitiesListDevicePairingsResponse = {
  devicePairings: EntitiesPairedDeviceResponse[]
}
export type EntitiesCreateDevicePairingResponse = {
  expiresAt: string
  id: string
  matchCode: string
  secret: string
}
export type EntitiesCreateDevicePairingRequest = {
  /** IssuerLabel is a human-readable name for the web client that created
    the pairing (e.g. "Chrome on macOS"), shown on the phone before the
    user confirms. When omitted the phone sees a label derived from the
    creating request's User-Agent. */
  issuerLabel?: string
}
export type DevicePairingStatus =
  | 'pending'
  | 'claimed'
  | 'confirmed'
  | 'rejected'
  | 'revoked'
  | 'expired'
export type EntitiesDevicePairingResponse = {
  claimedAt?: string | null
  confirmedAt?: string | null
  deviceName?: string | null
  expiresAt: string
  id: string
  matchCode: string
  status: DevicePairingStatus
}
export type EntitiesDevicePairingOrganization = {
  id: string
  name: string
  slug: string
}
export type EntitiesDevicePairingUser = {
  id: string
  name: string
  username: string
}
export type EntitiesClaimDevicePairingResponse = {
  expiresAt: string
  issuerLabel: string
  matchCode: string
  organization: EntitiesDevicePairingOrganization
  user: EntitiesDevicePairingUser
}
export type EntitiesClaimDevicePairingRequestBody = {
  deviceName: string
  secret: string
}
export type EntitiesCreateSessionResponse = {
  accessToken: string
  id: string
  refreshToken: string
  userId: string
}
export type EntitiesDevicePairingSecretRequestBody = {
  secret: string
}
export type EntitiesGroupResponse = {
  createdAt: string
  createdByUserId: string
  description: string
  id: string
  name: string
  updatedAt: string
}
export type EntitiesListGroupsResponse = {
  hasNext: boolean
  hasPrev: boolean
  items: EntitiesGroupResponse[]
  page: number
  pages: number
  perPage: number
  total: number
}
export type EntitiesCreateGroupRequest = {
  description: string
  name: string
}
export type EntitiesUpdateGroupRequest = {
  description?: string
  name?: string
}
export type EntitiesGroupMemberResponse = {
  createdAt: string
  enabled: boolean
  name: string
  userId: string
  username: string
}
export type EntitiesAddGroupMembersRequest = {
  userIds: string[]
}
export type EntitiesRoleResponse = {
  createdAt: string
  description: string
  id: string
  name: RbacRole
  products: string[]
}
export type EntitiesListRolesResponse = {
  hasNext: boolean
  hasPrev: boolean
  items: EntitiesRoleResponse[]
  page: number
  pages: number
  perPage: number
  total: number
}
export type EntitiesRoleAssignmentResponse = {
  createdAt: string
  id: string
  name: string
  role: EntitiesRoleResponse
  roleId: string
  scope: string[]
  userId: string
  username: string
}
export type EntitiesListRoleAssignmentsResponse = {
  hasNext: boolean
  hasPrev: boolean
  items: EntitiesRoleAssignmentResponse[]
  page: number
  pages: number
  perPage: number
  total: number
}
export type EntitiesCreateRoleAssignmentResponse = {
  createdAt: string
  id: string
  roleId: string
  scope: string[]
  userId: string
}
export type EntitiesCreateRoleAssignmentRequestBody = {
  roleId: string
  scope: string[]
  userId: string
}
export type EntitiesRoleAssignmentMemberResponse = {
  createdAt: string
  id: string
  name: string
  roleId: string
  scope: string[]
  userId: string
  username: string
}
export type EntitiesRoleAssignmentGroupResponse = {
  assignmentCount: number
  assignments: EntitiesRoleAssignmentMemberResponse[]
  role: EntitiesRoleResponse
}
export type EntitiesListGroupedRoleAssignmentsResponse = {
  hasNext: boolean
  hasPrev: boolean
  items: EntitiesRoleAssignmentGroupResponse[]
  page: number
  pages: number
  perPage: number
  total: number
}
export type EntitiesUpdateRoleAssignmentResponse = {
  createdAt: string
  id: string
  roleId: string
  scope: string[]
  updatedAt: string
  userId: string
}
export type EntitiesUpdateRoleAssignmentRequestBody = {
  scope: string[]
}
export type EntitiesDeleteRoleAssignmentResponse = {
  status: string
}
export type EntitiesCreateSessionRequest = {
  organizationSlug: string
  otp?: string
  password: string
  username: string
}
export type EntitiesLdapAuthMethod = {
  enabled: boolean
}
export type EntitiesOidcConfig = {
  authority: string
  client_id: string
  client_secret?: string
  custom_protocol_name?: string
  redirect_uri: string
  scope: string
}
export type EntitiesOidcAuthMethod = {
  config?: EntitiesOidcConfig
  enabled: boolean
}
export type EntitiesStandardAuthMethod = {
  defaultOrganizationId?: string
  defaultOrganizationSlug?: string
  enabled: boolean
  multiOrgEnabled: boolean
}
export type EntitiesAuthenticationConfigResponse = {
  ldap: EntitiesLdapAuthMethod
  oidc_desktop: EntitiesOidcAuthMethod
  oidc_web: EntitiesOidcAuthMethod
  standard: EntitiesStandardAuthMethod
}
export type EntitiesCreateOidcSessionRequest = {
  accessToken: string
  client: 'desktop' | 'web'
  idToken: string
}
export type EntitiesRecoverPasswordRequest = {
  newPassword: string
  organizationSlug: string
  recoveryCode: string
  username: string
}
export type EntitiesRefreshSessionRequest = {
  refreshToken: string
}
export type EntitiesListUsersResponse = {
  hasNext: boolean
  hasPrev: boolean
  items: EntitiesUserResponse[]
  page: number
  pages: number
  perPage: number
  total: number
}
export type EntitiesCreateUserResponse = {
  password: string
  user: EntitiesUserResponse
}
export type EntitiesCreateUserRequest = {
  email?: string
  name: string
  username: string
}
export type EntitiesCheckMfaResponse = {
  mfaEnabled: boolean
}
export type EntitiesCheckMfaRequest = {
  organizationSlug: string
  password: string
  username: string
}
export type EntitiesUpdateCurrentUserRequest = {
  email?: string
  name?: string
  username?: string
}
export type EntitiesUpdateCurrentPasswordRequest = {
  currentPassword: string
  newPassword: string
}
export type EntitiesEnableMfaRequest = {
  code: string
}
export type EntitiesGenerateMfaSecretResponse = {
  mfaSecret: string
  qrCodeUrl: string
}
export type EntitiesChangeInitialPasswordResponse = {
  recoveryCode?: string
}
export type EntitiesChangeInitialPasswordRequest = {
  currentPassword: string
  newPassword: string
}
export type EntitiesResetUserPasswordResponse = {
  newPassword: string
}
export type EntitiesListUserSessionsResponse = {
  items: EntitiesSessionResponse[]
}
export type EntitiesCreateUserSessionBody = {
  /** ExpiresInSeconds bounds the issued access token. Optional: when omitted
    the token lives for 365 days. */
  expiresInSeconds?: number
}
export const {
  useCreateApiKeyMutation,
  useListDevicePairingsQuery,
  useLazyListDevicePairingsQuery,
  useCreateDevicePairingMutation,
  useGetDevicePairingQuery,
  useLazyGetDevicePairingQuery,
  useRevokeDevicePairingMutation,
  useClaimDevicePairingMutation,
  useConfirmDevicePairingMutation,
  useRejectDevicePairingMutation,
  useGetGroupsQuery,
  useLazyGetGroupsQuery,
  useCreateGroupMutation,
  useGetGroupQuery,
  useLazyGetGroupQuery,
  useDeleteGroupMutation,
  useUpdateGroupMutation,
  useGetGroupMembersQuery,
  useLazyGetGroupMembersQuery,
  useAddGroupMembersMutation,
  useRemoveGroupMemberMutation,
  useGetRolesQuery,
  useLazyGetRolesQuery,
  useGetRoleAssignmentsQuery,
  useLazyGetRoleAssignmentsQuery,
  useCreateRoleAssignmentMutation,
  useGetGroupedRoleAssignmentsQuery,
  useLazyGetGroupedRoleAssignmentsQuery,
  useUpdateRoleAssignmentMutation,
  useDeleteRoleAssignmentMutation,
  useGetRoleAssignmentsForRoleQuery,
  useLazyGetRoleAssignmentsForRoleQuery,
  useLoginMutation,
  useGetAuthenticationConfigQuery,
  useLazyGetAuthenticationConfigQuery,
  useSessionOidcAuthenticationMutation,
  useAccountRecoveryMutation,
  useRefreshSessionMutation,
  useLogoutMutation,
  useGetUsersQuery,
  useLazyGetUsersQuery,
  useCreateUserMutation,
  useCheckMfaMutation,
  useGetCurrentUserQuery,
  useLazyGetCurrentUserQuery,
  useUpdateAccountInfoMutation,
  useDeleteCurrentUserMfaMutation,
  useUpdateCurrentUserPasswordMutation,
  useEnableMfaMutation,
  useCurrentUserGenerateMfaSecretMutation,
  useChangeInitialPasswordMutation,
  useUpdateUserMutation,
  useDisableUserMutation,
  useEnableUserMutation,
  useUpdateUserPasswordMutation,
  useListUserSessionsQuery,
  useLazyListUserSessionsQuery,
  useCreateUserSessionMutation,
  useDeleteUserSessionMutation
} = injectedRtkApi
